import { gql } from 'graphql-request'

export const EXPORT_WRITER_DASHBOARD = gql`
  query ExportWriterDashboard($startDate: DateTime, $endDate: DateTime) {
    exportWriterDashboard(startDate: $startDate, endDate: $endDate)
  }
`
